/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S3_Li2Inputs */

const en_guide_json_rest_api_s3_li2 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Collection</strong>: <code>&#123;"data": [...], "total": 100, "page": 1&#125;</code> includes pagination`)
};

const ko_guide_json_rest_api_s3_li2 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>컬렉션</strong>: <code>&#123;"data": [...], "total": 100, "page": 1&#125;</code>에 페이지네이션 포함`)
};

const ja_guide_json_rest_api_s3_li2 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>コレクション</strong>: <code>&#123;"data": [...], "total": 100, "page": 1&#125;</code>にページネーションを含む`)
};

/**
* | output |
* | --- |
* | "<strong>Collection</strong>: <code>&#123;\"data\": [...], \"total\": 100, \"page\": 1&#125;</code> includes pagination" |
*
* @param {Guide_Json_Rest_Api_S3_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s3_li2 = /** @type {((inputs?: Guide_Json_Rest_Api_S3_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S3_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s3_li2(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s3_li2(inputs)
	return ja_guide_json_rest_api_s3_li2(inputs)
});